<template>
  <div>
    <div class="box box__selected">
      <a @click="sidebarChangePanel('types')" class="box-back has-icon--left">
        <i class="fa fa-arrow-left"></i> {{ $t('edit.sidebar.format') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions([
    'sidebarChangePanel',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Header.vue?58ac9eef
 **/